import React, { PureComponent } from 'react';
import { Translate } from 'react-localize-redux';
import styled from 'styled-components';

import Button from '../../components/button';
import Heading, { SubHeading } from '../../components/heading';
import Link from '../../components/link';
import Modal from '../../components/modal';
import SegmentedTranslate from '../../hocs/segmented-translate';
import BACKGROUND from './badge.png';
import ColumnedSection from './columned-section';

/**
 * Semi-transparent overlay
 */
const Background = styled.div`
  background: #f0f0f0;
  color: #111111;
  position: relative;
`;

const WatermarkContainer = styled.div`
  text-align: center;
  position: absolute;
  top: calc(50% - 8em);
  width: 100%;
  @media (max-width: 767px) {
    top: 10em;
  }
`;

const Watermark = styled.img`
  opacity: 0.15;
  width: 16em;
`;

const ImportantText = styled.div`
  line-height: 1.5em;
  text-align: center;
  font-weight: bold;
  font-size: 1.2em;
  line-height: 1.8em;
`;

const MarkerText = styled.span`
  background: black;
  color: white;
  padding: 0 0.8em;
`;

const DescriptionContainer = styled.div`
  border-radius: 0.2em;
  padding: 1.5em;
  text-align: center;
`;

const Text = styled.p`
  margin: 0 0 0.2em;
  white-space: pre-line;
  line-height: 1.6em;
  font-weight: bold;
`;

const Note = styled.p`
  margin: 0;
  color: #919191;
  line-height: 1.6em;
`;

const ModalText = styled.p`
  white-space: pre-line;
`;

const PreviousStoryButton = styled.div`
  text-align: center;
  width: 14em;
  display: block;
  margin: 1em auto 0;
`;

/**
 * Mission section
 */
class Mission extends PureComponent {
  state = {
    showInfo: false
  };
  handleInfoClick = () => {
    this.setState({ showInfo: true });
  };

  closeInfo = () => {
    this.setState({ showInfo: false });
  };
  render() {
    const { gameId } = this.props;
    return (
      <Background>
        <WatermarkContainer>
          <Watermark src={BACKGROUND} />
        </WatermarkContainer>
        <ColumnedSection
          title={
            <div>
              <Heading>MISSION</Heading>
              <SubHeading>
                <Translate id="landingPage.mission.subtitle" />
              </SubHeading>
            </div>
          }
        >
          <ImportantText>
            <div>
              <MarkerText>
                <SegmentedTranslate
                  id={`landingPage.mission.${gameId}.intro.1`}
                />
              </MarkerText>
            </div>
            <div>
              <MarkerText>
                <SegmentedTranslate
                  id={`landingPage.mission.${gameId}.intro.2`}
                />
              </MarkerText>
            </div>
            <div>
              <MarkerText>
                <SegmentedTranslate
                  id={`landingPage.mission.${gameId}.intro.3`}
                />
              </MarkerText>
            </div>
          </ImportantText>
          <DescriptionContainer>
            <Text>
              <SegmentedTranslate id={`landingPage.mission.${gameId}.main.1`} />
            </Text>
            <Text>
              <SegmentedTranslate id={`landingPage.mission.${gameId}.main.2`} />
            </Text>
            <Text>
              <SegmentedTranslate id={`landingPage.mission.${gameId}.main.3`} />
            </Text>
            <Text>
              <SegmentedTranslate id={`landingPage.mission.${gameId}.main.4`} />
            </Text>
            <Text>
              <SegmentedTranslate id={`landingPage.mission.${gameId}.main.5`} />
            </Text>
            <Note>
              <Translate id={`landingPage.mission.${gameId}.note`} />
            </Note>
            {+gameId === 1 && (
              <PreviousStoryButton onClick={this.handleInfoClick}>
                <Button>
                  <Translate id={`landingPage.mission.${gameId}.button`} />
                </Button>
              </PreviousStoryButton>
            )}
          </DescriptionContainer>
          {this.state.showInfo && (
            <Modal
              onClose={this.closeInfo}
              title={
                <Translate id={`landingPage.mission.${gameId}.modalTitle`} />
              }
            >
              <ModalText>
                <Translate id={`landingPage.mission.${gameId}.modalInfo`} />
              </ModalText>
              <ModalText>
                <Link to={`/games/${+gameId - 1}/`}>
                  <Translate id={`landingPage.mission.${gameId}.modalLink`} />
                </Link>
              </ModalText>
            </Modal>
          )}
        </ColumnedSection>
      </Background>
    );
  }
}
export default Mission;
